import React, { useState, useEffect, useCallback } from 'react';
import { required, ReferenceField, ReferenceInput, SingleFieldList, ChipField, ArrayField, AutocompleteArrayInput, 
	AutocompleteInput, ReferenceArrayInput, FunctionField, NumberField, SelectArrayInput, Button, Toolbar, SaveButton, 
	TabbedForm, NumberInput, FormTab, FormDataConsumer, ArrayInput, SimpleFormIterator, Edit, Create, BooleanInput, 
	EditButton, Filter, List, Datagrid, DateField, TextField, TextInput, SelectInput, BooleanField, Labeled, downloadCSV }
	from 'react-admin';
import { AppBar, Tabs, Tab, Box, Typography, Divider, Chip, CircularProgress, Paper } from '@material-ui/core';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import jsonExport from 'jsonexport/dist';
import { Card, CardHeader, CardContent } from '@material-ui/core/';
import { getRiskScoreColor, COLORS } from './styles/ivt';
import LinkIcon from '@material-ui/icons/Link';
import IvtMetricBoxes from './components/IvtMetricBoxes';
import { AdstxtComponent } from './components/ads.txt';
import {ScheduledReportButton} from "./components/schedule_report_button.js";
import { CustomDateField, SectionHeader } from './components/utils';
import { TabPanel } from './components/TabPanel';
import NoBidBannerAd from './components/NoBidBannerAd';
import EntityToolbar from './components/EntityTooolbar';
import TrafficPanel from './components/TrafficPanel';
import SyncPixelField from './components/SyncPixelField';
const mediaCategories = require('./components/media_categories.json');
const specialCategories = require('./components/special_categories.json');
const utils = require('./components/utils');
const { validInteger } = require('./components/validation');
const prebidBidders = require('./prebidBidderModules.json');

let globalRole = 'publisher';
// Report timezone choices moved to components/utils.js as REPORT_TIMEZONES -
// the identical array was declared in three separate files.

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.paper,
    width: 500,
  },
}));


function IvtSummaryBadge({ publisherCode }) {
  const [history, setHistory] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchHistory = useCallback(() => {
    if (!publisherCode) return;
    const token = localStorage.getItem('token');
    fetch(`${window.nobid_endpoint}/ivt_publisher_scan/history?publisher_code=${publisherCode}&limit=20`, {
      headers: { 'Authorization': `Bearer ${token}` }
    })
      .then(r => r.json())
      .then(result => { setHistory(Array.isArray(result) ? result : []); setLoading(false); })
      .catch(() => setLoading(false));
  }, [publisherCode]);

  useEffect(() => { fetchHistory(); }, [fetchHistory]);

  useEffect(() => {
    window.addEventListener('ivt-scan-updated', fetchHistory);
    return () => window.removeEventListener('ivt-scan-updated', fetchHistory);
  }, [fetchHistory]);

  if (loading) return <CircularProgress size={16} style={{ marginLeft: '8px' }} />;
  if (!history.length) return (
    <Typography variant="body2" color="textSecondary" style={{ marginBottom: '8px' }}>
      No IVT scan data available. Run an IVT scan from the Traffic tab.
    </Typography>
  );

  const latest = history[0];

  return (
    <Box style={{ marginBottom: '8px' }}>
      <IvtMetricBoxes scanHistory={history} />
      <Typography variant="caption" color="textSecondary" style={{ display: 'block', marginTop: '4px' }}>
        {latest.sample_size != null && <>Sample size: {latest.sample_size}</>}
        {latest.sample_size != null && latest.scan_timestamp && <> &middot; </>}
        {latest.scan_timestamp && <>Last scanned: {new Date(latest.scan_timestamp).toLocaleString()}</>}
      </Typography>
    </Box>
  );
}

const twoColumnGrid = { display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '0 24px', width: '50%' };
const fullWidth = { gridColumn: '1 / -1' };

function AnalyticsTabs({permissions, ...props}) {
  const classes = useStyles();
  const theme = useTheme();
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <div className={classes.root} style={{width: '50%'}}>
      <AppBar position="static" color="default" style={{width: '100%'}}>
        <Tabs value={value} onChange={handleChange} indicatorColor="primary" textColor="primary" variant="fullWidth" aria-label="full width tabs example">
          <Tab label="Prebid Settings"/>
					<Tab label="Amazon TAM Settings"/>
					<Tab label="Optimizer Settings"/>
        </Tabs>
      </AppBar>
      <TabPanel value={value} index={0} dir={theme.direction} style={{width: '90%'}}>
				<div style={{width: '100%'}}>
				<div>Analytics Settings</div>
				<BooleanInput source='wrapup_config.analyticsEnabled' label='Enable Analytics Adapter' style={{width: '50%'}}/>
				<AutocompleteArrayInput label="Analytics Allowed Bidders" source="wrapup_config.analytics_allowed_bidders" choices={prebidBidders}
					fullWidth helperText= "Allow Analtyics for these bidders for this Publisher. Keep this list empty if you want to allow all bidders."/>
				</div>
      </TabPanel>
			<TabPanel value={value} index={1} dir={theme.direction} style={{width: '100%'}}>
				<div style={{width: '100%'}}>
				<div>Amazon TAM Settings</div>
				<br/>
				<BooleanInput source='tam_config.enabled' label='Enable Amazon TAM for reporting and bidding' style={{width: '50%'}}/>
				<br/>
				<TextInput source='tam_config.pubID' label='Amazon TAM pubID (Publisher ID)' style={{width: '30%'}}/>
				<br/>
				<utils.ReportTimezoneSelectInput source="tam_config.timezone" label="Reporting Timezone" style={{width: '50%'}}/>
				<br/>
				<TextInput source="tam_config.publisherUuid" label="Reporting publisherUuid" style={{width: '50%'}}/>
				<br/>
        <TextInput source="tam_config.reportId" label="Reporting reportId" style={{width: '50%'}}/>
				<br/>
        <TextInput source="tam_config.versionId" label="Reporting versionId" style={{width: '50%'}}/>
				<br/>
				<TextInput source="tam_config.accessKeyId" label="Reporting accessKeyId" style={{width: '50%'}}/>
				<br/>
        <TextInput source="tam_config.secretAccessKey" label="Reporting secretAccessKey" style={{width: '50%'}}/>
				</div>
      </TabPanel>
      <TabPanel value={value} index={2} dir={theme.direction} style={{width: '200%'}}>
				<BooleanInput source='wrapup_config.carbonizerEnabled' label='Enable Auction Optimizer' style={{width: '50%'}}/>
				<div style={{marginTop: '15px'}}>Auction Optimzer Settings</div>
				<div style={{display: 'flex', gap: '20px', width: '70%', margin: '20px'}}>
					<div style={{width: '50%'}}>
						<div style={{display: 'grid'}}>
						<div>Minimum IMPRESSIONS globally set to 1 impression by default.</div>
						<NumberInput source="wrapup_config.carbonizer.impressions_minimum" label="Minimum Impressions" style={{width: '50%'}}
								helperText="Block inventory where impressions is less or equal to the minimum" />
						</div>

						<br/>
						<div style={{display: 'grid'}}>
						<div>Minimum REVENUE globally set to $0.001 by default.</div>
						<NumberInput source="wrapup_config.carbonizer.revenue_minimum" label="Minimum Revenue ($)" style={{width: '50%'}}
								helperText="Block inventory where revenue is less or equal to the minimum" />
						</div>

						<br/>
						<div style={{display: 'grid'}}>
						<div>Minimum RESPONSE RATE defined as #bid responses / #bid requests.</div>
						<NumberInput source="wrapup_config.carbonizer.bid_responses_rate_minimum" label="Minimum Response Rate %" style={{width: '50%'}}
								helperText="Block inventory where bid response rate is less or equal to the minimum (bid responses/bid requests)"/>
						</div>

						{/* <br/>
						<div style={{display: 'grid'}}>
						<div>Minimum FILL RATE defined as #impressions / #ad requests.</div>
						<NumberInput source="wrapup_config.carbonizer.fill_rate_minimum" label="Minimum Fill Rate %" style={{width: '50%'}}
								helperText="Block inventory where fill rate is less or equal to the minimum (impressions/ad requests)."/>
						</div> */}

						<br/>
						<div style={{display: 'grid'}}>
						<div>Minimum RPM defined as Revenue per Million Bid Requests (1,000,000 * $revenue / #bid requests).</div>
						<NumberInput source="wrapup_config.carbonizer.rpm_bid_requests_minimum" label="Minimum RPM Rate ($)" style={{width: '50%'}}
								helperText="Block inventory where RPM is less or equal to the minimum (1,000,000 * $revenue/#bid requests)."/>
						</div>
					</div>
					<div style={{width: '50%'}}>
						The Auction Optimizer minimizes wasteful requests resulting in: faster page speed, increased profitability and carbon emissions reduction.
						<ul>
						<li>The Auction Optimizer uses the last 10 days including today's data to build the optimization model.</li>
						<li>The Optimizer uses a rules based system to determine the best inventory "pockets".</li>
						<li>Currently the following inventory parameter are part of the selection algorithm:</li>
							<ul>
								<li>Bidder</li>
								<li>Site</li>
								<li>Country</li>
								<li>Device</li>
								<li>Browser</li>
								<li>Ad Type (Banner or Video)</li>
								<li>Ad size (Coming soon)</li>
							</ul>
							<li>The auction optimizer runs constantly to "optimize" your inventory.</li>
							<li>The auction optimizer runs an A/B test experiment to monitor the optimization results.</li>
						</ul>
						<hr/>
						<h4>Developers Implementation Notes</h4>
						There are 2 ways to use the NoBid Auction Optimizer:
						<ol>
							<li>If you are using the NoBid Carbon Wrapper, the Optimizer is already implemented and the developers don't need to code any changes.</li>
							<li>If you are NOT using the NoBid Carbon Wrapper, you would need to enable the NoBid Analytics Adapter in your Prebid wrapper.
								Next, you need to turn on the Auction Optimizer in this section and implement the following lines of code in your site.
							<pre><code>{'if (typeof nobidCarbonizer !== \'undefined\') {\n' +
								'   nobidCarbonizer.carbonizeAdunits(adunits);\n' +
							'}'
							}
							</code></pre>
							This code is to be applied on the set of adunits you have put in place for your page.
							<br/>Please contact Support for any questions related to the implementation.
							</li>
						</ol>
					</div>
					</div>
      </TabPanel>
    </div>
  );
}

const PublisherTitle = ({ record }) => {
	return <span>Publisher {record && record.name ? `"${record.name}"` : 'Create'}</span>;
};

const PublisherFilter = ({permissions, ...props}) => (
	<Filter {...props}>
		<TextInput label="Search" source="search_name" alwaysOn resettable />
		{/* <ReferenceArrayInput source="network_id" label="Networks"
      reference="networks"
			basePath='networks'
			resettable
      perPage={10}
      sort={{ field: 'name', order: 'ASC' }}
      filterToQuery={searchText => ({ search_name: searchText })}
    >
      <AutocompleteArrayInput label="Networks" optionText="name" optionValue="code" style={{ width: '90%' }} />
    </ReferenceArrayInput> */}
		<NumberInput label="Publisher ID" source="search_id" resettable />
		<BooleanInput source="wrapup_config.analyticsEnabled" label="Analytics Enabled" defaultValue={true} resettable />
	</Filter>
);
const exporter = (sites, permissions) => {
	const sitesForExport = sites.map(site => {
			let o = {
					id: site.code, name: site.name, active: site.active
			};
			if (globalRole === 'admin') {
				o.wtd_impressions = site.revenue_stats && site.revenue_stats.total_impressions ? site.revenue_stats.total_impressions : 0;
				o.wtd_revenue = site.revenue_stats && site.revenue_stats.total_revenue ? site.revenue_stats.total_revenue : 0;
				o.wtd_ad_requests = site.revenue_stats && site.revenue_stats.total_ad_requests ? site.revenue_stats.total_ad_requests : 0;
			}
			return o;
	});
	let headers = ['id', 'name', 'active'];
	if (globalRole === 'admin') {
		headers = headers.concat(['wtd_impressions', 'wtd_revenue', 'wtd_ad_requests']);
	}
	jsonExport(sitesForExport, {
			headers: headers
	}, (err, csv) => {
			downloadCSV(csv, 'sites');
	});
};
export const PublisherList = ({permissions,...props}) => {
	globalRole = (permissions) ? permissions.role : 'publisher';
	return (
		<span>
		<List {...props} filters={<PublisherFilter />} perPage={25} bulkActionButtons={false} exporter={exporter}>
			<Datagrid rowClick="edit">
				<TextField source="code" label="ID" />
				<TextField source="name" label="Name" />
				{permissions && permissions.role === 'admin' &&
						[
						<NumberField source="revenue_stats.total_impressions" label="WTD Impressions" />,
						<NumberField source="revenue_stats.total_revenue" label="WTD Revenue" options={{ style: 'currency', currency: 'USD' }} />,
						<NumberField source="revenue_stats.total_ad_requests" label="WTD Ad Requests" />,
						<FunctionField label="IVT Scan" sortBy="reputation_info.risk_score" render={record => {
							const info = record.reputation_info;
							if (!info) return <Chip size="small" label="No Scan" style={{ backgroundColor: COLORS.GREY, color: '#fff' }} />;
							return <Chip size="small" label={`${info.risk_score}%`} style={{ backgroundColor: getRiskScoreColor(info.risk_score), color: '#fff' }} />;
						}} />
						]
				}
				<DateField source="updated_at" label="Update Date" />
				<DateField source="created_at" label="Creation Date" />
				<BooleanField source="active" label="Active" />
				<EditButton variant="contained" color="primary" />
			</Datagrid>
		</List>
		{ permissions && permissions.role === 'admin' && <NoBidBannerAd code="square" /> }
		</span>
	)
};

export const PublisherEdit = ({ permissions, ...props }) => (
	<Edit title={<PublisherTitle />} mutationMode="pessimistic" {...props}>
		<TabbedForm toolbar={<EntityToolbar />}>
			<FormTab label="Publisher Settings" {... props}>
				{permissions && permissions.role === 'admin' &&
          <Box style={twoColumnGrid}>
            <SectionHeader title="IVT Summary" />
            <FormDataConsumer>
              {({ formData }) => formData && formData.code ? (
                <Box style={fullWidth}>
                  <IvtSummaryBadge publisherCode={formData.code} />
                </Box>
              ) : null}
            </FormDataConsumer>

            <SectionHeader title="General" />
            <BooleanInput source="active" label="Active" defaultValue={true} validate={required()} />
            <Labeled label="Publisher ID">
              <TextField source="code" style={{ fontSize: '1rem' }} />
            </Labeled>
            <TextInput source="name" label="Publisher Name" validate={required()} style={{ maxWidth: 256 }} />
            <TextInput source="domain_name" label="Domain Name" validate={required()} style={{ maxWidth: 256 }} />
            <SelectInput label="Seller Type" source="seller_type"
              helperText=""
              choices={[
                { id: "PUBLISHER", name: "PUBLISHER" },
                { id: "BOTH", name: "BOTH" },
                { id: "INTERMEDIARY", name: "INTERMEDIARY" },
              ]} validate={required()}  style={{ maxWidth: 256 }}/>
            <TextInput source="schain_id" label="Supply Chain ID" helperText="Override for Publisher ID." style={{ maxWidth: 256 }} />

            <Box style={fullWidth}>
              <BooleanInput source="fast_lane_enabled"
                label="Enable Fast Lane"
								style={{ display: 'none' }}
                helperText="Fast lane enables for faster ad rendering by skipping GAM/DFP. Use this flag with caution b/c this will eliminate Google Dynamic Allocation revenue. Only use for sites that are not approved on Google."
              />
            </Box>
            <FormDataConsumer>
              {({ formData, getSource, ...rest }) => !formData.fast_lane_enabled && <>
              <SectionHeader title="GAM / MCM Settings" />
              <Box style={{ ...fullWidth, display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '0 24px', padding: '20px', marginBottom: '20px', borderRadius: '9px', border: '1px white solid' }}>
                <ReferenceInput source="parent_gam_account_id" label="MCM Parent GAM Network ID"
                  reference="gam_accounts"
                  sort={{ field: 'code', order: 'ASC' }}>
                  <SelectInput optionText={(record) => `${record.name} (${record.network_code})`}
                    optionValue="code"
                    defaultValue={1}
                    validate={required()}
                    disabled={formData && formData.fast_lane_enabled ? true : false}/>
                </ReferenceInput>
                <TextInput source="gam_account_id"
                  label="GAM Network ID"
                  helperText="Only required if Publisher is MCM Approved."
                  style={{ maxWidth: 256 }}
                />
                <Box style={{ gridColumn: '1 / -1', marginTop: '10px' }}>
                  <ArrayField source="ad_unit_paths" addLabel='Ad Unit Paths'>
                    <SingleFieldList>
                      <ChipField source="name" label="Ad Path Name" />
                    </SingleFieldList>
                  </ArrayField>
                </Box>
              </Box>
              </>
              }
            </FormDataConsumer>

            <SectionHeader title="Revenue & Pricing" />
            <SelectInput source="payment_terms" label="Payment Terms" initialValue='60'
              helperText='Determines the number of days before payment is issued to the Publisher.'
              choices={[
                { id: 30, name: 'Net 30' },
                { id: 45, name: 'Net 45' },
                { id: 60, name: 'Net 60' }
              ]} 
							 style={{ maxWidth: 256 }}/>
            <NumberInput source="revshare" label={`${utils.getOrgName()} Revshare`} helperText={`Revshare taken out from the Publisher's revenue. 30 means 30% for ${utils.getOrgName()} and 70% for the Publisher. This revshare can be overriden by the Site or Bidder Revshare.`}  style={{ maxWidth: 256 }}/>
            <NumberInput source="pub_revshare" label="Publisher Revshare" helperText={`This is a revshare that needs to be applied on top of ${utils.getOrgName()} Revshare. Leave this blank if you are not sure.`}  style={{ maxWidth: 256 }}/>
            <NumberInput source="hard_floor" label="Hard Floor" helperText="Any price or prediction below this value will be rejected. In US Dollars."  style={{ maxWidth: 256 }}/>
            <NumberInput source="auction_timeout_ms" label="Auction Timeout (ms)" step={1} validate={validInteger} helperText="Maximum time in milliseconds to wait for bidders to respond before closing the auction." style={{ maxWidth: 256 }}/>
            <ReferenceInput source="ron_site_id" label="RON Site"
              reference="sites"
              basePath='sites'
              sort={{ field: 'name', order: 'ASC' }}
              filterToQuery={searchText => ({ publisher_id: props.id, search_name: searchText })}
              allowEmpty emptyText="- None -"
							 style={{ maxWidth: 256 }}
            >
              <AutocompleteInput label="Sites" optionText="name" optionValue="code" />
            </ReferenceInput>
            <ReferenceField reference="sites" source="ron_site_id" label="">
              <NumberField source="name" />
            </ReferenceField>

            <SectionHeader title="Algorithm & Optimization" />
            <SelectInput label="Prediction Strategy" source="prediction_strategy" allowEmpty emptyText="- None -"
              helperText="Standard: bid price is the combination of Tag and AdX DA, Conservative the bid price is only the Tag price."
              choices={[
                { id: "STANDARD", name: 'Standard' },
                { id: "CONSERVATIVE", name: 'Conservative' }
              ]} 
							 style={{ maxWidth: 256 }}/>
            <SelectInput label="Viewability" source="viewability" allowEmpty emptyText="- None -"
              choices={[
                { id: 1, name: 'At 1%' },
                { id: 10, name: 'At 10%' },
                { id: 20, name: 'At 20%' },
                { id: 30, name: 'At 30%' },
                { id: 40, name: 'At 40%' },
                { id: 50, name: 'At 50%' },
                { id: 60, name: 'At 60%' },
                { id: 70, name: 'At 70%' },
                { id: 80, name: 'At 80%' },
                { id: 90, name: 'At 90%' },
                { id: 100, name: 'At 100%' }
              ]} 
							 style={{ maxWidth: 256 }}
            />
            {/* <BooleanInput source="is_exclusive_deal" label="Exclusive Deal Member" helperText="Only Bidders in an Exclusive Deal are enabled for this Publisher. Setup an Exclusive deal in the Deals sections for this Publisher." /> */}

            <SectionHeader title="Feature Flags" />
            <BooleanInput source="http_request_log_enabled" label="Enable HTTP Request Logging" />
            <BooleanInput source="domain_overrides_site_id_enabled" label="Enable site domain overrides site ID" />

            <SectionHeader title="Team" />
            <ReferenceInput source="sales_rep" label="Sales Representative"
              reference="users"
              basePath='users'
              sort={{ field: 'name', order: 'ASC' }}
              filterToQuery={searchText => ({ search_name: searchText })}
              allowEmpty emptyText="- None -">
              <AutocompleteInput label="Users" optionText="name" optionValue="code" />
            </ReferenceInput>
            <ReferenceField label="Sales Representative" source="sales_rep" reference="users">
              <TextField source="name" />
            </ReferenceField>
            <ReferenceArrayInput source="account_manager_ids" label="Account Managers"
              filter={{role: 'admin'}}
              reference="users"
              basePath='users'
              perPage={15}
              sort={{ field: 'name', order: 'ASC' }}
              filterToQuery={searchText => ({ search_name: searchText })}>
              <AutocompleteArrayInput optionText="name" optionValue="code" />
            </ReferenceArrayInput>
          </Box>
				}

				{(permissions && permissions.role === 'publisher') &&
          <Box style={twoColumnGrid}>
            <SectionHeader title="General" />
            <Labeled label="Active">
              <BooleanField source="active" />
            </Labeled>
            <Labeled label="Publisher ID">
              <TextField source="code" style={{ fontSize: '1rem' }} />
            </Labeled>
            <Labeled label="Publisher Name">
              <TextField source="name" style={{ fontSize: '1rem' }} />
            </Labeled>
            <Labeled label="Domain Name">
              <TextField source="domain_name" style={{ fontSize: '1rem' }} />
            </Labeled>
          </Box>
        }
			</FormTab>

			<FormTab label='Prebid Wrapper'>
				<AnalyticsTabs props={props} />
      </FormTab>

			{permissions && permissions.role === 'admin' &&
				<FormTab label="Bidder Settings">
					<br/>
					<ReferenceArrayInput label="Allowed Bidders"
						perPage={15}
						sort={{ field: 'name', order: 'ASC' }}
						filter={{ hidden: false }}
						filterToQuery={searchText => ({ search_name: searchText })}
						source="allowed_bidders"
						reference="bidders"
						basePath='bidders'
						allowEmpty emptyText="- None -">
						<AutocompleteArrayInput optionText={record => (record && record.name) ? `${record.name} (${record.code})` : ""}
							optionValue="code" helperText="Only allow these bidders for this Publisher. Keep this list empty if you want to allow all bidders" style={{ width: '200px' }} />
					</ReferenceArrayInput>

					<br/>

					{/* <SelectInput style={{ width: '350px' }} source="default_bidder_id" 
					label="Default Prediction Bidder" 
					choices={utils.BIDDERS_PREDICTORS} /> */}

					<>Bidder Config</>
					<ArrayInput source="bidder_config">
						<SimpleFormIterator>
							<SelectInput style={{ width: '350px' }} source="bidder_id" label="Bidder" choices={utils.BIDDERS_SELECTABLE} />
							<FormDataConsumer>
								{({ formData, scopedFormData, getSource, ...rest }) => scopedFormData
									&& utils.BIDDERS_REQUIRE_SITE_ID.includes(scopedFormData.bidder_id)
									&& [<span style={{ fontSize: 'small' }}>{utils.BIDDERS_REQUIRE_SITE_ID_LABEL[scopedFormData.bidder_id] || 'Site ID'}</span>, <br/>, <TextInput {...props} style={{ width: '350px' }} label="Site ID" source={getSource('site_id')} {...rest} />]
								}
							</FormDataConsumer>
							<FormDataConsumer>
									{({ formData, scopedFormData, getSource, ...rest }) => scopedFormData
												&& (utils.BIDDERS_REQUIRE_SEAT_ID.includes(scopedFormData.bidder_id)) &&
											[<span style={{ fontSize: 'small' }}>{utils.BIDDERS_REQUIRE_SEAT_ID_LABEL[scopedFormData.bidder_id] || 'Seat ID'}</span>, <br/>, <TextInput {...props} style={{ width: '350px' }} label="Seat ID" source={getSource('seat_id')} {...rest} />]
									}
							</FormDataConsumer>
							<FormDataConsumer>
									{({ formData, scopedFormData, getSource, ...rest }) => scopedFormData
												&& (utils.BIDDERS_REQUIRE_PUBLISHER_ID.includes(scopedFormData.bidder_id)) &&
											[<span style={{ fontSize: 'small' }}>{utils.BIDDERS_REQUIRE_PUBLISHER_ID_LABEL[scopedFormData.bidder_id] || 'Publisher ID'}</span>, <br/>, <TextInput {...props} style={{ width: '350px' }} label="Publisher ID" source={getSource('publisher_id')} {...rest} />]
									}
							</FormDataConsumer>
							<FormDataConsumer>
								{({ formData, scopedFormData, getSource, ...rest }) => scopedFormData && scopedFormData.bidder_id === '304' &&
									<TextInput {...props} label="Site ID" source={getSource('site_id')} {...rest} style={{ width: '350px' }} validate={required()} />
								}
							</FormDataConsumer>
							<FormDataConsumer>
								{({ formData, scopedFormData, getSource, ...rest }) => scopedFormData
									&& utils.BIDDERS_PREDICTION_DISABLABLE.includes(scopedFormData.bidder_id)
									&&
									<BooleanInput {...props} label="Disable Prediction" source={getSource('prediction_disabled')} helperText="Set this flag when we still have reports related to this site but we don't want to have bids at the moment." {...rest} />
								}
							</FormDataConsumer>
							<FormDataConsumer>
								{({ formData, scopedFormData, getSource, ...rest }) => scopedFormData && scopedFormData.bidder_id === '101' &&
									<span>
										<TextInput {...props} style={{ width: '350px' }} multiline label="Size Tags" source={getSource('size_tags')} helperText="Format: 300x25:ID\n728x90:ID" {...rest} />
										<BooleanInput {...props} label="Disable Prediction" source={getSource('prediction_disabled')} helperText="Set this flag when we still have reports related to this site but we don't want to have bids at the moment." {...rest} />
									</span>
								}
							</FormDataConsumer>
						</SimpleFormIterator>
					</ArrayInput>
				</FormTab>
			}

			<FormTab label="Report Settings">

				{permissions && permissions.role === 'admin' &&
					[
					<NumberInput source="rtb_net_revenue_adjustment" label="RTB Net Revenue Adjustment"
						helperText="This adjustment will be applied in reporting for the net RTB revenue. A value of 1.1 means that the net revenue will be increased by 10% for RTB bidders ONLY."
						style={{ width: '30%' }} />,
					<ReferenceArrayInput source="rtb_net_revenue_adjustment_bidders"
						reference="bidders"
						basePath="bidders"
						perPage={15}
						sort={{ field: 'name', order: 'ASC' }}
						filter={{bidder_type: 'RTB'}}
						filterToQuery={searchText => ({ search_name: searchText })}
						allowEmpty 
						style={{ width: '100%' }}>
						<AutocompleteArrayInput label="RTB Net Revenue Adjustment Bidders"
							optionText={choice => choice && choice.name ? `${choice.name} (${choice.code})` : ''}
							optionValue="code" style={{ width: '100%' }} />
					</ReferenceArrayInput>
					]
				}

				<h3 style={{ width: '50%' }}>OpenRTB Bid Request End-point:</h3>
				<FunctionField label="URL" render={record => `http://ads.servenobid.com/ortb_adreq?pubid=${record.code}`} />
				<br />

				<h3 style={{ width: '50%' }}>CTV Video VAST Tag:</h3>
				<FunctionField label="URL" render={record => `https://ads.servenobid.com/adreq?siteId=${record.code}&chnl=app&video=1&passback=1&nopredict=0&ip=[IPV4_ADDRESS]&ua=[USER_AGENT]&app_bundle=[APP_BUNDLE]&app_name=[APP_NAME]&app_store_url=[SOTRE_URL_ENCODED]&did=[DEVICE_ID]&usp=[US_PRIVACY]&cb=[CACHE_BUSTER]&width=[PLAYER_WIDTH]&height=[PLAYER_HEIGHT]&floor=0.01`} />
				<br />

				<h3 style={{ width: '50%' }}>WEB Video VAST Tag:</h3>
				<FunctionField label="URL" render={record => `https://ads.servenobid.com/adreq?siteId=${record.code}&chnl=web&video=1&nopredict=0&passback=1&playback=AUTO_PLAY_SOUND_OFF&width=[PLAYER_WIDTH]&height=[PLAYER_HEIGHT]&floor=0.01&location=[PAGE_LOCATION_URL_ENCODED]`} />
				<br />

				<h3 style={{ width: '50%' }}>User Sync Pixel:</h3>
				<SyncPixelField />
				<br />

				<h3>Reporting API End-point:</h3>
				<FunctionField label="URL" render={record => `https://reports.nobid.io/report?pubid=${record.code}&token=<YOUR_API_TOKEN_HERE>&start=2020-03-20&end=2020-03-20`} />
				<br />

				<Card style={{ width: '90%' }} raised>
					<CardHeader title="Report API Settings" />
					<CardContent>
						{permissions && permissions.role === 'admin' &&
							<TextInput source="report_api_config.extra_metrics" label="Extra Metrics" multiline
								style={{ width: '50%' }} disabled />
						}
						{permissions && permissions.role === 'admin' &&
							<ReferenceArrayInput source="report_api_config.excluded_bidders" label="Exclude Bidders"
								reference="bidders"
								basePath="bidders"
								perPage={15}
								sort={{ field: 'name', order: 'ASC' }}
								filterToQuery={searchText => ({ search_name: searchText })}
								allowEmpty style={{ width: '50%' }}>
								<AutocompleteArrayInput label="Exclude Bidders"
									optionText={choice => choice && choice.name ? `${choice.name} (${choice.code})` : ''}
									optionValue="code" style={{ width: '50%' }} />
							</ReferenceArrayInput>
						}
						<br /><div style={{ width: '100%' }}>Default Dimensions: date, publisher, site, site_id</div>
						<SelectArrayInput label="Extra Dimensions" source="report_api_config.extra_dimensions" style={{ width: '50%' }}
							choices={[
								{ id: 'country', name: 'Country' },
								{ id: 'device', name: 'Device' },
								{ id: 'placement', name: 'Placement' },
								{ id: 'ad_type', name: 'Ad Type' },
								{ id: 'adsize', name: 'Ad Size' }
							]} />
					</CardContent>
				</Card>

				<br />
				<FormDataConsumer>
				{({ formData, ...rest }) =>
					(
							<ScheduledReportButton params={ {
								record: rest.record, 
								end_point: `/run_report?pubid=${rest.record.code}`
							} } />
					)
        }
				</FormDataConsumer>

				<Card style={{ width: '90%' }} raised>
					<CardHeader title="Scheduled Reports" />
					<CardContent>
						<ArrayInput source="report_schedule_config" label="" style={{ width: '50%' }}>
							<SimpleFormIterator>
								<br /><span>Scheduled Report Settings</span>
								<br /><div style={{ width: '100%' }}>Default Dimensions: date, publisher, site, site_id</div>
								<SelectArrayInput label="Extra Dimensions" source="extra_dimensions" style={{ width: '500px' }}
									choices={[
										{ id: 'country', name: 'Country' },
										{ id: 'device', name: 'Device' },
										{ id: 'placement', name: 'Placement' },
										{ id: 'ad_type', name: 'Ad Type' },
										{ id: 'adsize', name: 'Ad Size' }
									]} />

								<span>Select the sites you want to report on. If you want to report on all sites leave this field blank.</span>
								<ReferenceArrayInput alwaysOn source="sites" label="Sites"
									reference="sites"
									basePath="sites"
									perPage={10}
									sort={{ field: 'name', order: 'ASC' }}
									filter={{ publisher_id: props.id }}
									filterToQuery={searchText => ({ search_name: searchText })}
									allowEmpty style={{ width: '400px' }}>
									<AutocompleteArrayInput label="Sites" optionText={(permissions && permissions.role === 'admin') ? "adunit_path" : "name"} optionValue="code" />
								</ReferenceArrayInput>

								<br /><TextInput source="recipients" label="Recipients (comma seperated)" multiline style={{ width: '400px' }} helperText="name@company.com,anothername@company.com" />
								<br /><SelectInput label="Format" source="format" initialValue="csv"
									choices={[
										{ id: 'xls', name: 'Excel' },
										{ id: 'csv', name: 'CSV' }
									]} />

								<br />
								<SelectInput label="Time Period" source="days"
									initialValue="1"
									helperText="Select the time period you want the report to run."
									choices={[
										{ id: 1, name: 'Yesterday' },
										{ id: 7, name: 'Last 7 days' },
										{ id: 15, name: 'Last 15 days' },
										{ id: 30, name: 'Last 30 days' }
									]} />
							</SimpleFormIterator>
						</ArrayInput>
					</CardContent>
				</Card>
			</FormTab>

			<FormTab label="Ads.txt Settings">
				<FormDataConsumer>
					{({ formData }) => <AdstxtComponent publisherCode={formData.code} />}
				</FormDataConsumer>
			</FormTab>

			{permissions && ['admin', 'publisher'].includes(permissions.role) && !permissions.disabled_features?.includes('custom_ad_formats') &&
				<FormTab label="Custom Ad Formats">
					<h4>Combo Settings</h4>
					<div style={{border: '1px solid', width: 'fit-content', padding: '20px', borderRadius: '5px', marginBottom: '50px'}}>
					<BooleanInput source="combo_enabled" label="Combo Desktop 300x600 (2 * 300x250) Enabled" />
						<BooleanInput source="combo_large_enabled" label="Combo Desktop 970x250 (3 * 300x250) Enabled" />
						<BooleanInput source="combo_mobile_enabled" label="Combo Mobile 300x250 (2 * 320x50) Enabled" />

						<Button href="https://public.servenobid.com/partner/combo/index.html" label="Combo Demo" target="_blank" startIcon={<LinkIcon />} />
					</div>
					<h4>Opt-In Ad Categories</h4>
					<SelectArrayInput label="Special Ad Categories" source="special_ad_categories" choices={specialCategories} style={{minWidth: '285px', width: 'auto', maxWidth: '650px'}}/>

				</FormTab>
			}

 			{(permissions && permissions.role === 'admin') &&
				<FormTab label="Monitoring Settings">
					<br/>
					<BooleanInput source="monitoring.enabled" label="Monitoring Enabled" />
					<NumberInput source="monitoring.min_threshold" label="Minimum Revenue Percentage Threshold" defaultValue={90}
					helperText="Hourly revenue should NOT drop below this percentage value."
					style={{width: '20%'}}/>
					<br/>
					{/* <NumberInput source="monitoring.max_threshold" label="Maximum Percentage Threshold" defaultValue={100}
					helperText="Hourly or Daily revenue should NOT spike above this percentage value."
					style={{width: '20%'}}/>
					<br/> */}
					<NumberInput source="monitoring.min_threshold_daily" label="Minimum Daily Revenue Percentage Threshold" defaultValue="50"
					helperText="Daily revenue should NOT drop below this percentage value."
					style={{width: '20%'}}/>
					<br/>
					{/* <NumberInput source="monitoring.max_threshold_daily" label="Maximum Daily Percentage Threshold" defaultValue={90}
					helperText="Daily revenue should NOT spike above this percentage value."
					style={{width: '20%'}}/> */}
					<br/>
					<TextInput source="monitoring.email" label="Destination Notification Emails (comma separated)" 
					style={{width: '30%'}}/>
				</FormTab>
			}

			{permissions && permissions.role === 'admin' &&
				<FormTab label="Publisher Info">
					<h4>IAB Categories</h4>
					<ReferenceArrayInput source="iab_categories"
							reference="iab_categories"
							basePath='iab_categories'
							perPage={200}
							sort={{ field: 'name', order: 'DESC' }}
							filterToQuery={searchText => ({ search_name: searchText })}>
							<AutocompleteArrayInput label="IAB Categories" optionText="name" style={{ width: '90%' }} />
					</ReferenceArrayInput>
					<h4>Media Categories</h4>
					<SelectArrayInput source="media_categories" choices={mediaCategories} />
					<br/>
					<TextInput multiline source="publisher_info.notes" label="Notes" helperText="Special notes about this site." style={{ width: '40%' }} />

				</FormTab>
			}

			{permissions && permissions.role === 'admin' &&
					<FormTab label="Revenue Summary">
							<FunctionField label="Viewability" render={record => record.viewability || record.site_viewability ? utils.formatDouble(record.viewability || record.site_viewability, '%', 2) : 'N/A'} />
							<NumberField source="revenue_stats.total_impressions" label="Week To Date Impressions" />
							<NumberField source="revenue_stats.total_revenue" label="Week To Date Revenue ($)" options={{ style: 'currency', currency: 'USD' }} />
							<NumberField source="revenue_stats.total_ad_requests" label="Week To Date Ad Requests" />

							<ArrayField source="revenue_stats.daily">
									<Datagrid>
											<CustomDateField label="Date" />
											<NumberField source="impressions" label="Impressions" />
											<NumberField source="revenue" label="Revenue" options={{ style: 'currency', currency: 'USD' }} />
											<NumberField source="avg_cpm" label="CPM" options={{ style: 'currency', currency: 'USD' }} />
											<NumberField source="ad_requests" label="Ad_Requests" />
											<FunctionField render={record => record.fill_rate ? utils.formatDouble(record.fill_rate*100, '%') : '' } label="%Fill_Rate" />
									</Datagrid>
							</ArrayField>
					</FormTab>
			}

			{false && permissions && ['admin', 'publisher'].includes(permissions.role) &&
				<FormTab label="Statements">
					<h4 style={{width: '90%'}}>Month End Statements</h4>
					{permissions && permissions.role === 'admin' &&
					[<ArrayInput source="statements">
						<SimpleFormIterator>
						  <TextInput source="link" label="Statement Link" style={{ width: '90%' }} />
					    <TextInput source="description" label="Statement Description" style={{ width: '90%' }} />
						</SimpleFormIterator>
					</ArrayInput>
					,<br/>
				  ,<h4 style={{width: '90%'}}>Statements (Publisher View)</h4>]
		      }
					<ArrayField source="statements" label="" style={{width: '100%'}}>
						<Datagrid style={{ width: '90%' }}>
							<FunctionField label="" style={{width: '100%'}}
							render={record => <Button href={record.link} target="_blank" style={{width: '100%', whiteSpace: 'nowrap'}} label={record.description}/>} startIcon={<LinkIcon />} />
						</Datagrid>
					</ArrayField>

				</FormTab>
			}

			{permissions && permissions.role === 'admin' &&
				<FormTab label="Traffic">
					<SectionHeader title="Sampling & Logging" />
					<div style={{ display: 'grid', gridTemplateColumns: '320px 320px', gap: '0 24px' }}>
						<NumberInput source="traffic_sample_rate" validate={validInteger} defaultValue={100000} label="Incoming Sample Rate" helperText="1-in-N sampling of incoming requests (default 100,000). 0 = off, 1 = every request." fullWidth />
						<NumberInput source="outgoing_sample_rate" validate={validInteger} label="Outgoing Sample Rate" helperText="1-in-N sampling of outgoing responses, independent of incoming. Blank = inherit Incoming rate. 0 = off, 1 = every response." fullWidth />
					</div>
					<BooleanInput source="drop_nobids" label="Drop No-Bid Responses" helperText="On = log only responses that carry a bid (drops the no-bid firehose). Off (default) = log everything." />

					<FormDataConsumer>
						{({ formData }) => formData && formData.code ? (
							<TrafficPanel entityType="publisher" entityId={formData.code} entityName={formData.name} trafficTypes={['incoming_request', 'outgoing_response', 'bidrequest', 'bidresponse']} />
						) : null}
					</FormDataConsumer>
				</FormTab>
			}

		</TabbedForm>
	</Edit>
);

export const PublisherCreate = ({ permissions, ...props }) => (
	<Create title="Create Publisher" {...props} >
		<TabbedForm toolbar={<EntityToolbar />}>
			<FormTab label="Publisher Settings">

				{permissions && ['admin', 'network_admin', 'publisher'].includes(permissions.role) && [
					<BooleanInput source="active" label="Active" defaultValue={true} validate={required()} />,

					<TextInput source="name" label="Publisher Name" style={{ width: '400px' }} validate={required()} />
				]}

				{permissions && ['admin', 'publisher'].includes(permissions.role) &&
					<TextInput source="domain_name" label="Domain Name" style={{ width: '400px' }} validate={required()} />
				}

				{/* {permissions && permissions.role === 'admin' &&
					<ReferenceInput source="network_id" label="Network"
						reference="networks"
						perPage={10}
						sort={{ field: 'name', order: 'ASC' }}
						filterToQuery={searchText => ({ search_name: searchText })}
						allowEmpty>
						<AutocompleteInput label="Network" optionText="name" optionValue="code" style={{ width: '90%' }} />
					</ReferenceInput>
				} */}

				{permissions && permissions.role === 'admin' && <div>
					<BooleanInput style={{ width: '400px', display: 'none' }} source="fast_lane_enabled" label="Enable Fast Lane" defaultValue={true}
					helperText="Fast lane enables for faster ad rendering by skipping 'GAM/DFP. Use this flag with caution 
					b/c this will eliminate Google Dynamic Allocation revenue. Only use for sites that are not approved on Google."/>

					<br/>

					<FormDataConsumer>
						{({ formData, ...rest }) =>
						!formData.fast_lane_enabled &&
							<div style={{ display: 'grid', padding: '20px 0 0 20px', marginBottom: '20px', width: 'fit-content', borderRadius: '9px', border: '1px white solid' }}>
								<ReferenceInput source="parent_gam_account_id" label="MCM Parent GAM Network ID"
									reference="gam_accounts"
									sort={{ field: 'code', order: 'ASC' }}>
									<SelectInput
									optionText={(record) => `${record.name} (${record.network_code})`} 
									optionValue="code"
									defaultValue={1}
									style={{ width: '400px', marginRight: '20px' }}
									validate={required()} />
								</ReferenceInput>
								<TextInput
									source="gam_account_id"
									label="GAM Network ID"
									style={{ width: "400px" }}
									helperText='Only required if Publisher is MCM Approved.'/>
							</div>
						}
					</FormDataConsumer>

					<SelectInput label="Seller Type" source="seller_type"
						style={{ width: '400px' }}
						choices={[
							{ id: "PUBLISHER", name: "PUBLISHER" },
							{ id: "BOTH", name: "BOTH" },
							{ id: "INTERMEDIARY", name: "INTERMEDIARY" },
						]} validate={required()} />

					<NumberInput source="revshare" label={`${utils.getOrgName()} Revshare`} style={{ width: '400px' }} helperText={`30 means 30% for ${utils.getOrgName()} and 70% for the Publisher.`}/>

					<NumberInput source="pub_revshare" label="Publisher Revshare" style={{ width: '400px' }} helperText={`This is a revshare that needs to be applied on top of ${utils.getOrgName()} Revshare. Leave this blank if you are not sure.`}/>

					<TextInput source="schain_id" style={{ width: '400px' }} label="Supply Chain ID" helperText='Override for Publisher ID.'/>

					<ReferenceInput source="sales_rep" label="Sales Representative"
						reference="users"
						basePath='users'
						sort={{ field: 'name', order: 'ASC' }}
						filterToQuery={searchText => ({ search_name: searchText })}
						allowEmpty emptyText="- None -">
						<AutocompleteInput label="Users" optionText="name" optionValue="code" />
					</ReferenceInput>

					<ReferenceArrayInput source="account_manager_ids" label="Account Managers"
						filter={{role: 'admin'}}
						reference="users"
						basePath='users'
						perPage={15}
						sort={{ field: 'name', order: 'ASC' }}
						filterToQuery={searchText => ({ search_name: searchText })}>
						<AutocompleteArrayInput optionText="name" optionValue="code" />
					</ReferenceArrayInput>


					{/* // <SelectInput label="Prediction Strategy" source="prediction_strategy" allowEmpty emptyText="- None -"
					// 	helperText="Standard: bid price is the combination of Tag and AdX DA, Conservative the bid price is only the Tag price."
					// 	choices={[
					// 		{ id: "STANDARD", name: 'Standard' },
					// 		{ id: "CONSERVATIVE", name: 'Conservative' }
					// 	]}
					// />, */}

					<NumberInput source="hard_floor" label="Hard Floor" style={{ width: '400px' }} helperText='Any price or prediction below this value will be rejected. In US Dollars.'/>

					<NumberInput source="auction_timeout_ms" label="Auction Timeout (ms)" step={1} validate={validInteger} style={{ width: '400px' }} helperText='Maximum time in milliseconds to wait for bidders to respond before closing the auction.'/>

					{/* <BooleanInput source="is_exclusive_deal" label="Exclusive Deal Member" style={{ width: '400px' }} helperText='Only Bidders in an Exclusive Deal are enabled for this Publisher. Setup an Exclusive deal in the Deals sections for this Publisher.' /> */}

					<SelectInput label="Viewability" source="viewability" allowEmpty emptyText="- None -"
						choices={[
								{ id: 1, name:  'At 1%' },
								{ id: 10, name: 'At 10%' },
								{ id: 20, name: 'At 20%' },
								{ id: 30, name: 'At 30%' },
								{ id: 40, name: 'At 40%' },
								{ id: 50, name: 'At 50%' },
								{ id: 60, name: 'At 60%' },
								{ id: 70, name: 'At 70%' },
								{ id: 80, name: 'At 80%' },
								{ id: 90, name: 'At 90%'},
								{ id: 100, name: 'At 100%'}
						]}
					/>
					</div>
				}
			</FormTab>

			{permissions && permissions.role === 'admin' &&
				<FormTab label="Bidder Settings">
					{/* <SelectInput style={{ width: '350px' }} source="default_bidder_id" 
					label="Default Prediction Bidder" 
					choices={utils.BIDDERS_PREDICTORS} /> */}
          
					{/* <hr style={{ width: '100%' }} /> */}

					<ArrayInput source="bidder_config">
						<SimpleFormIterator>
							<SelectInput style={{ width: '350px' }} source="bidder_id" label="Bidder" 
							choices={utils.BIDDERS_SELECTABLE} />
							<FormDataConsumer>
								{({ formData, scopedFormData, getSource, ...rest }) => scopedFormData
									&& utils.BIDDERS_REQUIRE_SITE_ID.includes(scopedFormData.bidder_id)
									&& [<span style={{ fontSize: 'small' }}>{utils.BIDDERS_REQUIRE_SITE_ID_LABEL[scopedFormData.bidder_id] || 'Site ID'}</span>, <br/>, <TextInput {...props} style={{ width: '350px' }} label="Site ID" source={getSource('site_id')} {...rest} />]
								}
							</FormDataConsumer>
							<FormDataConsumer>
									{({ formData, scopedFormData, getSource, ...rest }) => scopedFormData
												&& (utils.BIDDERS_REQUIRE_SEAT_ID.includes(scopedFormData.bidder_id)) &&
											[<span style={{ fontSize: 'small' }}>{utils.BIDDERS_REQUIRE_SEAT_ID_LABEL[scopedFormData.bidder_id] || 'Seat ID'}</span>, <br/>, <TextInput {...props} style={{ width: '350px' }} label="Seat ID" source={getSource('seat_id')} {...rest} />]
									}
							</FormDataConsumer>
							<FormDataConsumer>
									{({ formData, scopedFormData, getSource, ...rest }) => scopedFormData
												&& (utils.BIDDERS_REQUIRE_PUBLISHER_ID.includes(scopedFormData.bidder_id)) &&
											[<span style={{ fontSize: 'small' }}>{utils.BIDDERS_REQUIRE_PUBLISHER_ID_LABEL[scopedFormData.bidder_id] || 'Publisher ID'}</span>, <br/>, <TextInput {...props} style={{ width: '350px' }} label="Publisher ID" source={getSource('publisher_id')} {...rest} />]
									}
							</FormDataConsumer>
							<FormDataConsumer>
								{({ formData, scopedFormData, getSource, ...rest }) => scopedFormData && scopedFormData.bidder_id === '304' &&
									<TextInput {...props} label="Site ID" source={getSource('site_id')} {...rest} style={{ width: '350px' }} validate={required()} />
								}
							</FormDataConsumer>
							<FormDataConsumer>
								{({ formData, scopedFormData, getSource, ...rest }) => scopedFormData
									&& utils.BIDDERS_PREDICTION_DISABLABLE.includes(scopedFormData.bidder_id)
									&&
									<BooleanInput {...props} label="Disable Prediction" source={getSource('prediction_disabled')} helperText="Set this flag when we still have reports related to this site but we don't want to have bids at the moment." {...rest} />
								}
							</FormDataConsumer>
							<FormDataConsumer>
								{({ formData, scopedFormData, getSource, ...rest }) => scopedFormData && scopedFormData.bidder_id === '101' &&
									<span>
										<TextInput {...props} style={{ width: '350px' }} multiline label="Size Tags" source={getSource('size_tags')} helperText="Format: 300x25:ID\n728x90:ID" {...rest} />
										<BooleanInput {...props} label="Disable Prediction" source={getSource('prediction_disabled')} helperText="Set this flag when we still have reports related to this site but we don't want to have bids at the moment." {...rest} />
									</span>
								}
							</FormDataConsumer>
						</SimpleFormIterator>
					</ArrayInput>
				</FormTab>
			}

			<FormTab label="Report Settings">

			  {permissions && permissions.role === 'admin' &&
					[
					<NumberInput source="rtb_net_revenue_adjustment" label="RTB Net Revenue Adjustment"
						helperText="This adjustment will be applied in reporting for the net RTB revenue. A value of 1.1 means that the net revenue will be increased by 10% for RTB bidders ONLY."
						style={{ width: '30%' }} />,
					<ReferenceArrayInput source="rtb_net_revenue_adjustment_bidders"
						reference="bidders"
						basePath="bidders"
						perPage={15}
						sort={{ field: 'name', order: 'ASC' }}
						filter={{bidder_type: 'RTB'}}
						filterToQuery={searchText => ({ search_name: searchText })}
						allowEmpty 
						style={{ width: '100%' }}>
						<AutocompleteArrayInput label="RTB Net Revenue Adjustment Bidders"
							optionText={choice => choice && choice.name ? `${choice.name} (${choice.code})` : ''}
							optionValue="code" style={{ width: '100%' }} />
					</ReferenceArrayInput>
					]
			  }

				<h3>Reporting API End-point:</h3>
				<FunctionField label="URL" render={record => `https://reports.nobid.io/report?pubid=${record.code}&token=<YOUR_API_TOKEN_HERE>&start=2020-03-20&end=2020-03-20`} />
				<br />

				<Card style={{ width: '90%' }} raised>
					<CardHeader title="Report API Settings" />
					<CardContent>
						{permissions && permissions.role === 'admin' &&
							<TextInput source="report_api_config.extra_metrics" label="Extra Metrics" multiline style={{ width: '50%' }} disabled />
						}
						<br /><div style={{ width: '100%' }}>Default Dimensions: date, publisher, site, site_id</div>
						<SelectArrayInput label="Extra Dimensions" source="report_api_config.extra_dimensions" style={{ width: '50%' }}
							choices={[
								{ id: 'country', name: 'Country' },
								{ id: 'device', name: 'Device' },
								{ id: 'placement', name: 'Placement' },
								{ id: 'ad_type', name: 'Ad Type' },
								{ id: 'adsize', name: 'Ad Size' }
							]} />
					</CardContent>
				</Card>

				<Card style={{ width: '90%' }} raised>
					<CardHeader title="Scheduled Reports" />
					<CardContent>
						<ArrayInput source="report_schedule_config" label="" style={{ width: '50%' }}>
							<SimpleFormIterator>
								<br /><span>Scheduled Report Settings</span>
								<br /><div style={{ width: '100%' }}>Default Dimensions: date, publisher, site, site_id</div>
								<SelectArrayInput label="Extra Dimensions" source="extra_dimensions" style={{ width: '500px' }}
									choices={[
										{ id: 'country', name: 'Country' },
										{ id: 'device', name: 'Device' },
										{ id: 'placement', name: 'Placement' },
										{ id: 'ad_type', name: 'Ad Type' },
										{ id: 'adsize', name: 'Ad Size' }
									]} />

								<span>Select the sites you want to report on. If you want to report on all sites leave this field blank.</span>
								<ReferenceArrayInput alwaysOn source="sites" label="Sites"
									reference="sites"
									basePath='sites'
									perPage={10}
									sort={{ field: 'name', order: 'ASC' }}
									filter={{ publisher_id: props.id }}
									filterToQuery={searchText => ({ search_name: searchText })}
									allowEmpty style={{ width: '400px' }}>
									<AutocompleteArrayInput label="Sites" optionText={(permissions && permissions.role === 'admin') ? "adunit_path" : "name"} optionValue="code" />
								</ReferenceArrayInput>

								<br /><TextInput source="recipients" label="Recipients (comma seperated)" multiline style={{ width: '400px' }} helperText="name@company.com,anothername@company.com" />
								<br /><SelectInput label="Format" source="format" initialValue="csv"
									choices={[
										{ id: 'xls', name: 'Excel' },
										{ id: 'csv', name: 'CSV' }
									]} />

								<br />
								<SelectInput label="Time Period" source="days"
									initialValue="1"
									helperText="Select the time period you want the report to run."
									choices={[
										{ id: 1, name: 'Yesterday' },
										{ id: 7, name: 'Last 7 days' },
										{ id: 15, name: 'Last 15 days' },
										{ id: 30, name: 'Last 30 days' },
										{ id: 365, name: 'Last 365 days' }
									]} />
							</SimpleFormIterator>
						</ArrayInput>
					</CardContent>
				</Card>
			</FormTab>

		 	{permissions && ['admin', 'publisher'].includes(permissions.role) && !permissions.disabled_features?.includes('custom_ad_formats') &&
				<FormTab label="Custom Ad Formats">
					<h4>Combo Settings</h4>
					<div style={{border: '1px solid', width: 'fit-content', padding: '20px', borderRadius: '5px', marginBottom: '50px'}}>
						<BooleanInput source="combo_enabled" label="Combo Desktop 300x600 (2 * 300x250) Enabled" />
						<BooleanInput source="combo_large_enabled" label="Combo Desktop 970x250 (3 * 300x250) Enabled" />
						<BooleanInput source="combo_mobile_enabled" label="Combo Mobile 300x250 (2 * 320x50) Enabled" />

						<Button href="https://public.servenobid.com/partner/combo/index.html" label="Combo Demo" target="_blank" startIcon={<LinkIcon />} />
					</div>
					<h4>Opt-In Ad Categories</h4>
					<SelectArrayInput label="Special Ad Categories" source="special_ad_categories" choices={specialCategories} style={{minWidth: '285px', width: 'auto', maxWidth: '650px'}}/>

				</FormTab>
			}

			{permissions && permissions.role === 'admin' &&
				<FormTab label="Publisher Info">
					<h4>IAB Categories</h4>
					<ReferenceArrayInput source="iab_categories"
							reference="iab_categories"
							basePath='iab_categories'
							perPage={200}
							sort={{ field: 'name', order: 'DESC' }}
							filterToQuery={searchText => ({ search_name: searchText })}>
							<AutocompleteArrayInput label="IAB Categories" optionText="name" style={{ width: '90%' }} />
					</ReferenceArrayInput>
					<h4>Media Categories</h4>
					<SelectArrayInput source="media_categories" choices={mediaCategories} />
					<br/>
					<TextInput multiline source="publisher_info.notes" label="Notes" helperText="Special notes about this site." style={{ width: '40%' }} />
				</FormTab>
			}

		</TabbedForm>
	</Create>
);